<template lang="pug">
    #app(:style="cssProps")
        router-view
</template>
<script>
export default {
    name: "App",
    data() {
        return {};
    },
    computed: {
        cssProps() {
            return {
                "--fontFamily": this.$store.getters.getFontFamily
            };
        }
    },
    mounted() {},
    created() {
        var link = document.querySelector("link[rel*='icon']") || document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = this.$store.state.platformPrefs.favicon.faviconName;
        document.getElementsByTagName("head")[0].appendChild(link);
    }
};
</script>

<style>
* {
    font-family: var(--fontFamily);
}
</style>



// WEBPACK FOOTER //
// src/App.vue